import type { VolunteeringInterestDto } from '../../models/volunteering/common/volunteeringInterestDto';
import { requests } from '../httpClient';

export const VolunteeringInterests = {
    getVolunteeringInterestsAsync: () => requests.get(`VolunteeringInterests`),
    updateVolunteeringInterestsAsync: (volunteeringInterests: VolunteeringInterestDto[]) =>
        requests.put(`VolunteeringInterests`, { volunteeringInterests: volunteeringInterests })
};
